import { api } from './api';
import type {
  SafetyIncidentStats,
  SafetyIncidentListResponse,
  SafetyIncidentListParams,
  SafetyIncidentDetail,
  UpdateSafetyIncidentBody,
  ContactCustomerResponse,
} from '../types/safetyIncidents';

const BASE_PATH = '/admin/safety-incidents';

export const getStats = async (): Promise<SafetyIncidentStats> => {
  const response = await api.get(`${BASE_PATH}/stats`);
  return response.data;
};

export const getList = async (params?: SafetyIncidentListParams): Promise<SafetyIncidentListResponse> => {
  const response = await api.get(BASE_PATH, { params });
  return response.data;
};

export const getDetail = async (id: number): Promise<SafetyIncidentDetail> => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

export const update = async (id: number, body: UpdateSafetyIncidentBody): Promise<SafetyIncidentDetail> => {
  const response = await api.patch(`${BASE_PATH}/${id}`, body);
  return response.data;
};

export const contactCustomer = async (id: number): Promise<ContactCustomerResponse> => {
  const response = await api.post(`${BASE_PATH}/${id}/contact-customer`);
  return response.data;
};

export const safetyIncidentsService = {
  getStats,
  getList,
  getDetail,
  update,
  contactCustomer,
};

export default safetyIncidentsService;
